<div class="container">
  <div class="header">
    <div class="header-buttons">
      <button
        mat-button
        class="header-button"
        [routerLink]="['/dashboard/notifications']"
        [ngClass]="{ active: activeSection === 'notifications' }"
      >
        Notifications
      </button>
      <button
        mat-button
        class="header-button"
        [routerLink]="['/dashboard/machineryStatus']"
        [ngClass]="{ active: activeSection === 'machineryStatus' }"
      >
        Status
      </button>
      <button
        mat-button
        class="header-button"
        [routerLink]="['/reports']"
        [ngClass]="{ active: activeSection === 'reports' }"
      >
        Reports
      </button>
    </div>

    <div class="toolbar">
      <div class="filters">
        <div class="filter">
          Plant
          <mat-form-field>
            <mat-select
              [(ngModel)]="selectedPlantId"
              (selectionChange)="onPlantChange($event.value)"
            >
              @for (plant of plants; track plant) {
                <mat-option [value]="plant.plantId">
                  {{ plant.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="filter">
          Month
          <mat-form-field>
            <mat-select [(ngModel)]="selectedMonth">
              @for (month of months; track month) {
                <mat-option [value]="month">
                  {{ month }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <button
          mat-raised-button
          class="search-button"
          (click)="searchReports()"
        >
          Search
        </button>
      </div>
    </div>
  </div>

  <div class="reports-root">
    <!-- Empty State Message -->
    @if (!isLoading && !dataSource) {
      <div class="empty-state-container">
        <p class="empty-state-message">
          Select a plant and month, then click Search to view reports
        </p>
      </div>
    }

    <!-- Loading Spinner -->
    @if (isLoading) {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    }

    <!-- Desktop View: Table -->
    @if (!isLoading && dataSource) {
      <div class="desktop-view">
        <mat-table [dataSource]="dataSource" class="reports-table">
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef class="col-status"
              >Status</mat-header-cell
            >
            <mat-cell
              *matCellDef="let element"
              (click)="openReport(element)"
              class="col-status"
            >
              <span class="status-dot" [ngClass]="element.status">
                @if (element.status === "ok") {
                  <img src="assets/icons/16px_check.svg" />
                } @else if (element.status === "warning") {
                  <img src="assets/icons/16px_warning-sign.svg" />
                } @else if (element.status === "nodata") {
                  <img src="assets/icons/24px_close.svg" style="width: 65%" />
                }
              </span>
            </mat-cell>
          </ng-container>

          <!-- Equipment Column -->
          <ng-container matColumnDef="equipment">
            <mat-header-cell *matHeaderCellDef class="col-equipment"
              >Equipment</mat-header-cell
            >
            <mat-cell
              *matCellDef="let element"
              (click)="openReport(element)"
              class="col-equipment"
              >{{ element.equipment }}</mat-cell
            >
          </ng-container>

          <!-- Equipment Type Column -->
          <ng-container matColumnDef="equipmentType">
            <mat-header-cell *matHeaderCellDef class="col-equipmentType"
              >Equipment type</mat-header-cell
            >
            <mat-cell
              *matCellDef="let element"
              (click)="openReport(element)"
              class="col-equipmentType"
              >{{ element.equipmentType }}</mat-cell
            >
          </ng-container>

          <!-- Failure Modes Column -->
          <ng-container matColumnDef="reportAnalyses">
            <mat-header-cell *matHeaderCellDef class="col-reportAnalyses"
              >Failure modes</mat-header-cell
            >
            <mat-cell
              *matCellDef="let element"
              (click)="openReport(element)"
              class="col-modes col-reportAnalyses"
            >
              <div class="modes">
                @for (fm of element.reportAnalyses; track fm) {
                  <span
                    class="mode"
                    [ngClass]="fm.status"
                    title="{{ fm.name }}"
                  >
                    <span class="icon">
                      @if (fm.status === "ok") {
                        <img
                          src="assets/icons/16px_check.svg"
                          style="margin-right: 10px"
                        />
                      } @else if (fm.status === "warning") {
                        <img
                          src="assets/icons/16px_warning-sign.svg"
                          style="margin-right: 10px"
                        />
                      } @else if (fm.status === "nodata") {
                        <img
                          src="assets/icons/24px_close.svg"
                          style="margin-right: 10px"
                        />
                      }
                    </span>
                    <span class="label">{{ fm.name }}</span>
                  </span>
                }
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="row-clickable"
          ></mat-row>
        </mat-table>
      </div>
    }

    <!-- Mobile View: List -->
    @if (!isLoading && dataSource) {
      <div class="mobile-view">
        <div class="equipment-list">
          @if (dataSource) {
            @for (entry of dataSource.data; track entry.id) {
              <div class="equipment-card" (click)="openReport(entry)">
                <div class="equipment-header">
                  <span class="status-icon" [ngClass]="entry.status">
                    @if (entry.status === "ok") {
                      <img src="assets/icons/16px_check.svg" />
                    } @else if (entry.status === "warning") {
                      <img src="assets/icons/16px_warning-sign.svg" />
                    } @else if (entry.status === "nodata") {
                      <img src="assets/icons/24px_close.svg" />
                    }
                  </span>
                  <div class="equipment-info">
                    <span class="equipment-name">{{ entry.equipment }}</span>
                    <span class="equipment-type">{{
                      entry.equipmentType
                    }}</span>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }

    <!-- Mobile Detail Panel -->
    @if (isDetailPanelOpen && selectedEntry) {
      <div class="detail-panel">
        <div class="detail-header">
          <span class="equipment-id">{{ selectedEntry.equipment }}</span>
          <button class="close-button" (click)="closeDetailPanel()">✕</button>
        </div>

        <div class="detail-content">
          <h3>Equipment condition report</h3>
          <p class="period-text">
            {{ getMonthDateRange(selectedMonth || "") }}
          </p>
          <!-- Failure Modes Display -->
          <div class="failure-modes-display">
            @for (fm of selectedEntry.reportAnalyses; track fm.name) {
              <span class="failure-badge" [ngClass]="fm.status">
                @if (fm.status === "ok") {
                  <img src="assets/icons/16px_check.svg" />
                } @else if (fm.status === "warning") {
                  <img src="assets/icons/16px_warning-sign.svg" />
                } @else if (fm.status === "nodata") {
                  <img src="assets/icons/24px_close.svg" />
                }
                <span>{{ fm.name }}</span>
              </span>
            }
          </div>

          <!-- Expandable Sections -->
          <mat-accordion multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Equipment details</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-content">
                <p>
                  <strong>Equipment Type:</strong>
                  {{ selectedEntry.equipmentType }}
                </p>
                <p>
                  <strong>Serial Number:</strong>
                  {{ selectedEntry.serialNumber }}
                </p>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel expanded="true">
              <mat-expansion-panel-header>
                <mat-panel-title>Reports</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-content">
                @for (fm of selectedEntry.reportAnalyses; track fm.name) {
                  @if (fm.message) {
                    <div style="margin-bottom: 16px">
                      <strong>{{ fm.name }}:</strong>
                      <div
                        [innerHTML]="fm.message | replace: '\n' : '<br>'"
                      ></div>
                    </div>
                  }
                }

                @if (allModesOk) {
                  <span>No issues found in the period.</span>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    }
  </div>
  <div class="footer">
    <button mat-button class="footer-button" [routerLink]="['/about']">
      App About
    </button>
  </div>
</div>
